(() => {
  const STORAGE_KEY = 'mk-shop-gender';
  const COOKIE_DAYS = 365;

  const setCookie = (value) => {
    const expires = new Date(Date.now() + COOKIE_DAYS * 864e5).toUTCString();
    document.cookie = `${STORAGE_KEY}=${value}; expires=${expires}; path=/; SameSite=Lax; Secure`;
  };

  const remember = (gender) => {
    if (gender !== 'women' && gender !== 'men') return;
    try {
      localStorage.setItem(STORAGE_KEY, gender);
    } catch (error) {
      // Ignore private-mode storage errors.
    }
    setCookie(gender);
    document.documentElement.dataset.shopGender = gender;
  };

  const currentFromUrl = () => {
    const view = new URLSearchParams(window.location.search).get('view');
    if (view === 'women' || view === 'men') return view;
    return document.documentElement.dataset.shopGender || '';
  };

  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest('[data-gender-select]');
      if (!trigger) return;
      remember(trigger.getAttribute('data-gender-select'));
    },
    true
  );

  const gender = currentFromUrl();
  if (gender) remember(gender);
})();
